import { Auth0ContextInterface, User } from "@auth0/auth0-react";
import { IAuthenticationContext } from "./IAuthenticationContext";

export default class AuthenticationContext implements IAuthenticationContext {

    constructor(auth0Context : Auth0ContextInterface<User>) {
        this.isLoading = auth0Context.isLoading;
        this.logout = auth0Context.logout;
        this.getIdTokenClaims = auth0Context.getIdTokenClaims;
        this.getAccessTokenSilently = auth0Context.getAccessTokenSilently;
        this.user = auth0Context.user;
    }
    user: User | undefined;
    getAccessTokenSilently: (options: any) => Promise<any>;

    isLoading: boolean;

    logout: (options?: any) => void;

    getIdTokenClaims: () => Promise<any>;
}